(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('announcement-bar');
    if (!bar) return;

    // ── Dismiss / close ──────────────────────────────────
    var closeBtn = document.getElementById('announcement-close');
    if (closeBtn) {
      // Respect previously dismissed state
      if (sessionStorage.getItem('ann-bar-dismissed') === '1') {
        bar.hidden = true;
      }
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        sessionStorage.setItem('ann-bar-dismissed', '1');
      });
    }

    // ── Auto-rotate messages ──────────────────────────────
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;

    var current = 0;
    // Setting stores seconds; convert to milliseconds for setInterval
    var interval = (parseInt(bar.dataset.rotateInterval, 10) || 4) * 1000;

    function nextSlide() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    setInterval(nextSlide, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrappers = document.querySelectorAll('.collection-filters-bar__pills-wrapper');
    
    wrappers.forEach(wrapper => {
      const container = wrapper.querySelector('.collection-filters-bar__pills');
      const prevBtn = wrapper.querySelector('.pill-nav-prev');
      const nextBtn = wrapper.querySelector('.pill-nav-next');
      
      if (!container || !prevBtn || !nextBtn) return;

      const updateArrows = () => {
        const isScrollable = container.scrollWidth > container.clientWidth;
        prevBtn.style.display = isScrollable && container.scrollLeft > 5 ? 'flex' : 'none';
        nextBtn.style.display = isScrollable && (container.scrollLeft + container.clientWidth < container.scrollWidth - 5) ? 'flex' : 'none';
      };

      prevBtn.addEventListener('click', () => {
        container.scrollBy({ left: -200, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        container.scrollBy({ left: 200, behavior: 'smooth' });
      });

      container.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      
      // Initial check
      setTimeout(updateArrows, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-categories')) {
    customElements.define('featured-categories', class FeaturedCategories extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.featured-categories__small-cards');
        this.heroSlider = this.querySelector('.category-card--slider');
        
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed) * 1000;
        this.loop = this.dataset.loop === 'true';
        
        if (this.autoplay && this.slider) {
          this.initAutoplay();
        }

        if (this.heroSlider && this.heroSlider.dataset.heroAutoplay === 'true') {
          this.initHeroAutoplay();
        }
      }
      
      initHeroAutoplay() {
        const speed = parseInt(this.heroSlider.dataset.heroSpeed) * 1000;
        let timer = setInterval(() => {
          const nextBtn = this.heroSlider.querySelector('.category-slider__arrow--next');
          if (nextBtn) {
            nextBtn.click();
          } else {
            // Manual fallthrough if arrows hidden
            const dots = this.heroSlider.querySelectorAll('.category-slider__dot');
            if (dots.length > 1) {
              let activeIndex = Array.from(dots).findIndex(dot => dot.classList.contains('is-active'));
              let nextIndex = (activeIndex + 1) % dots.length;
              dots[nextIndex].click();
            }
          }
        }, speed);

        this.heroSlider.addEventListener('touchstart', () => clearInterval(timer));
        this.heroSlider.addEventListener('mousedown', () => clearInterval(timer));
      }

      initAutoplay() {
        const start = () => {
          if (window.innerWidth >= 768 || !this.autoplay) return;
          if (this.timer) clearInterval(this.timer);

          this.timer = setInterval(() => {
            const cards = this.slider.querySelectorAll('.category-card:not(.category-card--clone)');
            const totalRealCards = cards.length;
            if (totalRealCards <= 1) return;
            
            const cardWidth = cards[0].offsetWidth + 20;
            
            if (this.slider.scrollLeft >= (totalRealCards * cardWidth) - 10) {
              if (this.loop) {
                this.slider.scrollTo({ left: 0, behavior: 'auto' });
              } else {
                clearInterval(this.timer);
                return;
              }
            }
            
            this.slider.scrollBy({ left: cardWidth, behavior: 'smooth' });
          }, this.speed);
        };
        
        const stop = () => clearInterval(this.timer);
        
        start();
        
        this.slider.addEventListener('touchstart', stop, { passive: true });
        this.slider.addEventListener('touchend', () => setTimeout(start, 2000), { passive: true });
        this.slider.addEventListener('mousedown', stop, { passive: true });
        this.slider.addEventListener('mouseup', () => setTimeout(start, 2000), { passive: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Mobile hamburger ── */
    var toggle    = document.getElementById('header-menu-toggle');
    var mobileNav = document.getElementById('header-mobile-nav');
    var scrim     = document.getElementById('header-mobile-scrim');
    var drawerClose = document.getElementById('header-drawer-close');

    function closeDrawer() {
      toggle.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');
      mobileNav.classList.remove('is-open', 'sub-open');
      document.body.style.overflow = '';
      if (scrim) scrim.classList.remove('is-visible');
      /* Close all sub-panels */
      mobileNav.querySelectorAll('.header__mob-sub.is-open').forEach(function (s) {
        s.classList.remove('is-open');
        s.setAttribute('aria-hidden', 'true');
      });
    }
    if (toggle && mobileNav) {
      toggle.addEventListener('click', function () {
        var isOpen = mobileNav.classList.contains('is-open');
        if (isOpen) {
          closeDrawer();
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          mobileNav.setAttribute('aria-hidden', 'false');
          mobileNav.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          if (scrim) scrim.classList.add('is-visible');
        }
      });
      /* Drawer header X close button */
      if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
      /* Clicking the scrim closes the drawer */
      if (scrim) scrim.addEventListener('click', closeDrawer);
    }

    /* ── Desktop mega menu — hover intent ── */
    var INTENT_DELAY = 120;
    var CLOSE_DELAY  = 200;
    var megaItems    = document.querySelectorAll('.header__nav-item--mega');

    megaItems.forEach(function (item) {
      var btn   = item.querySelector('.header__nav-link--mega');
      var panel = item.querySelector('.mega-panel');
      if (!btn || !panel) return;

      var openTimer  = null;
      var closeTimer = null;

      function openPanel() {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          // Close any other open panel first
          megaItems.forEach(function (other) {
            if (other !== item) closePanelOf(other);
          });
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }, INTENT_DELAY);
      }

      function closePanel() {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          btn.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
        }, CLOSE_DELAY);
      }

      function closePanelOf(el) {
        var b = el.querySelector('.header__nav-link--mega');
        var p = el.querySelector('.mega-panel');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (p) p.classList.remove('is-open');
      }

      item.addEventListener('mouseenter', openPanel);
      item.addEventListener('mouseleave', closePanel);
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', closePanel);

      /* Keyboard: toggle on Enter/Space, close on Escape */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            btn.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
          } else {
            megaItems.forEach(function (other) {
              if (other !== item) closePanelOf(other);
            });
            btn.setAttribute('aria-expanded', 'true');
            panel.classList.add('is-open');
          }
        }
        if (e.key === 'Escape') {
          btn.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
          btn.focus();
        }
      });

      /* Close when focus moves outside */
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          btn.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
        }
      });
    });

    /* Close all mega panels on outside click */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header__nav-item--mega')) {
        megaItems.forEach(function (item) {
          var b = item.querySelector('.header__nav-link--mega');
          var p = item.querySelector('.mega-panel');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.classList.remove('is-open');
        });
      }
    });

    /* ── Mega triggers → open sub-panel ── */
    /* (mobileNav is declared in the hamburger block above) */
    document.querySelectorAll('.header__mobile-mega-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-sub');
        var sub = document.getElementById(targetId);
        if (!sub) return;
        sub.classList.add('is-open');
        sub.setAttribute('aria-hidden', 'false');
        mobileNav.classList.add('sub-open');
        sub.querySelector('.header__mob-sub-back').focus();
      });
    });

    /* ── Back buttons → close sub-panel ── */
    document.querySelectorAll('.header__mob-sub-back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.closest('.header__mob-sub');
        if (!sub) return;
        sub.classList.remove('is-open');
        sub.setAttribute('aria-hidden', 'true');
        /* Close all inner accordions */
        sub.querySelectorAll('.header__mob-sub-acc-btn').forEach(function (ab) {
          ab.setAttribute('aria-expanded', 'false');
          var p = ab.nextElementSibling;
          if (p) p.classList.remove('is-open');
        });
        mobileNav.classList.remove('sub-open');
      });
    });

    /* ── Inner column accordions inside sub-panels ── */
    document.querySelectorAll('.header__mob-sub-acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel  = btn.nextElementSibling;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.classList.toggle('is-open', !isOpen);
      });
    });

    /* ── Mobile promo peek slider ── */
    document.querySelectorAll('.header__mobile-promo-slider').forEach(function (slider) {
      var strip       = slider.querySelector('.header__mobile-promo-strip');
      var slides      = slider.querySelectorAll('.header__mobile-promo');
      var total       = slides.length;
      var current     = 0;
      var touchStartX = 0;
      var GAP         = 10;

      if (total < 2) return;

      function getSlideWidth() {
        return slides[0].getBoundingClientRect().width;
      }

      function goTo(index) {
        current = (index % total + total) % total;
        strip.style.transform = 'translateX(-' + (current * (getSlideWidth() + GAP)) + 'px)';
      }

      /* ── Auto-slide logic ── */
      var autoSlideEnabled = slider.getAttribute('data-auto-slide') === 'true';
      var intervalTime     = parseInt(slider.getAttribute('data-interval')) || 5000;
      var autoSlideTimer   = null;

      function startAutoSlide() {
        if (!autoSlideEnabled || total < 2) return;
        stopAutoSlide();
        autoSlideTimer = setInterval(function() {
          goTo(current + 1);
        }, intervalTime);
      }

      function stopAutoSlide() {
        if (autoSlideTimer) clearInterval(autoSlideTimer);
      }

      /* Trigger auto-slide when sub-panel is opened */
      document.querySelectorAll('.header__mobile-mega-trigger').forEach(function(t) {
        t.addEventListener('click', function() {
          if (t.getAttribute('data-sub') === slider.closest('.header__mob-sub').id) {
            setTimeout(startAutoSlide, 400); 
          }
        });
      });

      /* Stop when back button or drawer close is clicked */
      document.querySelectorAll('.header__mob-sub-back, #header-drawer-close').forEach(function(b) {
        b.addEventListener('click', stopAutoSlide);
      });

      strip.addEventListener('touchstart', function (e) {
        stopAutoSlide();
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      strip.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
        startAutoSlide();
      }, { passive: true });

      /* Mouse drag fallback for desktop/theme-editor */
      var mouseDown = false, mouseStartX = 0;
      strip.addEventListener('mousedown', function (e) {
        stopAutoSlide();
        mouseDown = true; mouseStartX = e.clientX; e.preventDefault();
      });
      document.addEventListener('mouseup', function (e) {
        if (!mouseDown) return;
        mouseDown = false;
        var diff = mouseStartX - e.clientX;
        if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
        startAutoSlide();
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infrastructure"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const initSlider = () => {
      const sliders = document.querySelectorAll('.infrastructure__process.is-slider');
      
      sliders.forEach(slider => {
        const isAutoplay = slider.dataset.autoplay === 'true';
        const speed = parseInt(slider.dataset.speed) || 5000;
        
        if (!isAutoplay) return;
        
        let interval;
        const steps = slider.querySelectorAll('.process-step');
        let currentIndex = 0;
        
        const startAutoplay = () => {
          interval = setInterval(() => {
            currentIndex = (currentIndex + 1) % steps.length;
            const stepWidth = steps[0].offsetWidth;
            slider.scrollTo({
              left: stepWidth * currentIndex,
              behavior: 'smooth'
            });
          }, speed);
        };
        
        const stopAutoplay = () => {
          clearInterval(interval);
        };
        
        // Start autoplay
        startAutoplay();
        
        // Stop on interaction
        slider.addEventListener('touchstart', stopAutoplay);
        slider.addEventListener('mousedown', stopAutoplay);
        
        // Optional: restart after interaction ends
        slider.addEventListener('touchend', () => {
          stopAutoplay();
          startAutoplay();
        });
      });
    };

    initSlider();
    
    // Re-init for Shopify Theme Editor
    document.addEventListener('shopify:section:load', initSlider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Quantity Selector Logic
    const quantityContainer = document.querySelector('.quantity-selector');
    if (quantityContainer) {
      const input = quantityContainer.querySelector('input');
      const minusBtn = quantityContainer.querySelector('.minus');
      const plusBtn = quantityContainer.querySelector('.plus');

      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value);
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;
      });
    }

    // Variant Selection Logic
    const variantPills = document.querySelectorAll('.variant-pill');
    const variantIdInput = document.querySelector('input[name="id"]');
    const atcButton = document.querySelector('.btn--atc');
    const shopNowButton = document.querySelector('.btn--shop-now');
    const qtySelector = document.querySelector('.quantity-selector');
    
    variantPills.forEach(pill => {
      pill.addEventListener('click', () => {
        variantPills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        variantIdInput.value = pill.dataset.variantId;
        
        const isAvailable = pill.dataset.available === 'true';
        if (atcButton) {
          atcButton.disabled = !isAvailable;
          atcButton.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
        }
        if (shopNowButton) {
          shopNowButton.disabled = !isAvailable;
          if (isAvailable) {
            shopNowButton.style.opacity = '1';
            shopNowButton.style.pointerEvents = 'auto';
          } else {
            shopNowButton.style.opacity = '0.5';
            shopNowButton.style.pointerEvents = 'none';
          }
        }
        if (qtySelector) {
          const qtyButtons = qtySelector.querySelectorAll('.qty-btn');
          qtyButtons.forEach(btn => btn.disabled = !isAvailable);
          if (isAvailable) {
            qtySelector.style.opacity = '1';
            qtySelector.style.pointerEvents = 'auto';
          } else {
            qtySelector.style.opacity = '0.5';
            qtySelector.style.pointerEvents = 'none';
          }
        }
      });
    });
  });

  if (!customElements.get('complementary-recommendations')) {
    class ComplementaryRecommendations extends HTMLElement {
      connectedCallback() {
        const blockId = this.dataset.blockId;
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const target = doc.getElementById(blockId);
            if (target && target.innerHTML.trim().length > 0) {
              this.innerHTML = target.innerHTML;
            }
          });
      }
    }
    customElements.define('complementary-recommendations', ComplementaryRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-deals-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    initPromoDeals();
  });

  // Support Shopify customizer theme reload events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('section-promo-deals-banner') || event.target.querySelector('.promo-deals-section')) {
      initPromoDeals();
    }
  });

  function initPromoDeals() {
    const cards = document.querySelectorAll('.promo-deals__card');
    
    cards.forEach(function(card) {
      // Prevent multiple listeners
      if (card.dataset.listenerBound) return;
      card.dataset.listenerBound = 'true';

      card.addEventListener('click', function(event) {
        const copyEnabled = card.getAttribute('data-copy-enabled') === 'true';
        const code = card.getAttribute('data-code-value');
        const link = card.getAttribute('data-link-target');
        
        let copyTriggered = false;

        // If click to copy is enabled
        if (copyEnabled && code) {
          copyTriggered = true;
          
          // Execute clipboard copy
          copyToClipboard(code);

          const footer = card.querySelector('.promo-deals__card-footer');
          if (footer) {
            const labelEl = footer.querySelector('[data-label-text]');
            const codeEl = footer.querySelector('[data-code-text]');
            
            // Set dynamic success state
            footer.classList.add('is-copied');
            
            const originalLabel = labelEl.textContent;
            const originalCode = codeEl.textContent;

            labelEl.textContent = '✓ COPIED!';
            codeEl.textContent = 'CODE COPIED';

            // Revert back after 1.5s
            setTimeout(function() {
              footer.classList.remove('is-copied');
              labelEl.textContent = originalLabel;
              codeEl.textContent = originalCode;
            }, 1500);
          }
        }

        // If link exists, navigate to it
        if (link) {
          event.preventDefault();
          // Delay redirect slightly so user can witness the success transition
          const delay = copyTriggered ? 400 : 0;
          setTimeout(function() {
            window.location.href = link;
          }, delay);
        }
      });
    });

    function copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function(err) {
          console.error('Could not copy text: ', err);
          fallbackCopyText(text);
        });
      } else {
        fallbackCopyText(text);
      }
    }

    function fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      
      // Avoid scrolling to bottom
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (!successful) {
          console.warn('Fallback copy command was unsuccessful');
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrappers = document.querySelectorAll('.collection-filters-bar__pills-wrapper');
    
    wrappers.forEach(wrapper => {
      const container = wrapper.querySelector('.collection-filters-bar__pills');
      const prevBtn = wrapper.querySelector('.pill-nav-prev');
      const nextBtn = wrapper.querySelector('.pill-nav-next');
      
      if (!container || !prevBtn || !nextBtn) return;

      const updateArrows = () => {
        const isScrollable = container.scrollWidth > container.clientWidth;
        prevBtn.style.display = isScrollable && container.scrollLeft > 5 ? 'flex' : 'none';
        nextBtn.style.display = isScrollable && (container.scrollLeft + container.clientWidth < container.scrollWidth - 5) ? 'flex' : 'none';
      };

      prevBtn.addEventListener('click', () => {
        container.scrollBy({ left: -200, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        container.scrollBy({ left: 200, behavior: 'smooth' });
      });

      container.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      
      // Initial check
      setTimeout(updateArrows, 500);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
